import { render, staticRenderFns } from "./RadioButtonSet.vue?vue&type=template&id=82af72f0&"
import script from "./RadioButtonSet.vue?vue&type=script&lang=js&"
export * from "./RadioButtonSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports